import { render, staticRenderFns } from "./Proportion.vue?vue&type=template&id=685966ee"
import script from "./Proportion.vue?vue&type=script&lang=js"
export * from "./Proportion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports